import React from 'react';
import { Link } from 'react-router-dom';
import Contact from '../../pages/Contact/Contact';
import gif from '../../assets/text.gif';
const Nav = () => {
    
    return (
        <div>
            <div className="navbar bg-transparent absolute z-10">
            <div className="navbar-start">
                <div className="dropdown text-black">
                <label tabIndex={0} className="btn btn-white bg-gray border border-none lg:hidden">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                </label>
                <ul tabIndex={0} className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-white text-gray-700 rounded-box w-52">
                    <li ><Link className='text-bold' to="/">Home</Link></li>
                    <li><Link to="/about">About</Link></li>
                    
                    <li><Link to="/my-work">My Work</Link></li>
                    <li><Link to="/blog">Blog</Link></li>
                    {/*  */}
                    <li><Link to="/mobile-contact">Contact</Link></li>
                </ul>
                
                </div>
                <Link to="/" className="btn btn-ghost hover:bg-transparent text-black normal-case text-xl hidden lg:block"><img src={gif} alt=""/></Link>
            </div>
            <div className="navbar-end hidden lg:flex text-black">
                <ul className="menu menu-horizontal px-1 z-10 ">
                    <li  className='hover:bg-gray'><Link  to="/">Home</Link></li>
                    <li  className='hover:bg-gray'><Link to="/about">About</Link></li>
                    
                    <li  className='hover:bg-gray'><Link to="/my-work">My Work</Link></li>
                    <li  className='hover:bg-gray'><Link to="/blog">Blog</Link></li>
                  <li  className='hover:bg-gray'><label htmlFor="my-modal-3" className="">Contact
                  </label></li>
                  <Contact></Contact>
                    
                </ul>
            </div>
            
            </div>
        </div>
    );
};

export default Nav;